<template>
	<div>
		<modalconfirm supplier ref="modalApprovalRetur" @action="proccessRetur"></modalconfirm>
		<div class="text-h5">Approval Retur</div>
		<v-card class="mt-3" outlined>
			<v-card-text>
				<v-form>
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-autocomplete item-value="por_code" hide-details @change="getDetail(por_code)" v-model="por_code" :items="OptionReturforAccept" label="Kode Retur" :error-messages="responseError.por_id" @focus="responseError.por_id = ''" outlined dense color="cyan darken-2" no-data-text="Belum ada data tersedia">
								<template v-slot:item = {item}>
									{{item.por_code}} - {{item.warehouse_name}}
								</template>
								<template v-slot:selection = {item}>
									{{item.por_code}}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" v-if="Object.keys(detailRetur).length > 0">
							<div class="font-weight-bold">Detail Warehouse</div>
							<v-row>
								<v-col cols="12" sm="3" md="3">
									<div class="d-flex">
										<v-icon>mdi-warehouse</v-icon>
										<div class="pl-3">{{ detailRetur.warehouse_name }}</div>
									</div>
								</v-col>
								<v-col cols="12" sm="3" md="3">
									<div class="d-flex">
										<v-icon>mdi-phone</v-icon>
										<div class="pl-3">{{ detailRetur.warehouse_mobilephone }}</div>
									</div>
								</v-col>
								<v-col cols="12" sm="6" md="6">
									<div class="d-flex">
										<v-icon class="icon-align-top">mdi-map-marker</v-icon>
										<div class="pl-3">{{ addresText }}</div>
									</div>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12" class="pt-0">
							<v-data-table disable-pagination :headers="headers" :items="detailRetur.por_detail" hide-default-footer class="mt-2" no-data-text="Belum ada data tersedia">
								<template v-slot:item.supplier_product_name="{ item }">
									<div class="pt-2">{{ item.supplier_product_name }}</div>
								</template>
								<template v-slot:item.supplier_product_code="{ item }">
									<div class="pt-2">{{ item.supplier_product_code }}</div>
								</template>
								<template v-slot:item.quantity="{ item }">
									<div class="pt-2">{{ item.por_detail_quantity_requested | toNumber }}</div>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-3 pb-3">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" :disabled="!por_code" outlined class="text-capitalize" @click="reject">
					<div>Tolak</div>
				</v-btn>
				<v-btn color="grey darken-1" v-if="!por_code" disabled outlined class="text-capitalize">
					<div>Proses</div>
				</v-btn>
				<v-btn color="cyan darken-2" v-else dark depressed outlined class="text-capitalize" @click="approve">
					<div>Proses</div>
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			por_code: '',
			poProccess: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'supplier_product_name', sortable: true},
			{ text: 'Kode Produk', value: 'supplier_product_code', sortable: false},
			{ text: 'Jumlah Retur', value: 'quantity', sortable: false, align: 'center'},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('returSupplier', ['detailRetur', 'response', 'responseError', 'OptionReturforAccept']),

		addresText() {
			var data = []
			if (this.detailRetur) {
				if (this.detailRetur.warehouse_address)
					data.push(this.detailRetur.warehouse_address)
				if (this.detailRetur.warehouse_subdistrict_name)
					data.push(this.detailRetur.warehouse_subdistrict_name)
				if (this.detailRetur.warehouse_city_name)
					data.push(this.detailRetur.warehouse_city_name)
				if (this.detailRetur.warehouse_province_name)
					data.push(this.detailRetur.warehouse_province_name)
			}
			return data.join(', ')
		}
	},
	methods: {
		...mapActions('returSupplier', ['getDetailRetur', 'approveRetur', 'rejectRetur', 'getOptionReturforAccept']),
		...mapMutations('returSupplier', ['setDetailRetur', 'clearDataRetur']),
		...mapMutations(['setOverlay']),

		getDetail(code) {
			if (code) {
				this.getDetailRetur(code)
			} else {
				this.setDetailRetur({})
			}
		},
		approve(){
			this.poProccess = 'approve'
			let msg = "Yakin akan memproses Retur ini?"
			this.$refs.modalApprovalRetur.setMessage(msg)
			this.$refs.modalApprovalRetur.showConfirm()
		},
		reject(){
			this.poProccess = 'reject'
			let msg = "Yakin akan membatalkan Retur ini?"
			this.$refs.modalApprovalRetur.setMessage(msg)
			this.$refs.modalApprovalRetur.showConfirm()
		},
		async proccessRetur() {
			await this.setOverlay(true)
			await this.$refs.modalApprovalRetur.hideConfirm()
			if (this.poProccess == 'approve') {
				await this.approveRetur(this.detailRetur.por_id).then(() => {
					if (this.response.code == 200.) {
						this.por_code = ''
						this.setDetailRetur({})
						this.getOptionReturforAccept()
					}
				})
			} else if (this.poProccess == 'reject') {
				await this.rejectRetur(this.detailRetur.por_id).then(() => {
					if (this.response.code == 200.) {
						this.por_code = ''
						this.setDetailRetur({})
						this.getOptionReturforAccept()
					}
				})
			}
			await this.setOverlay(false)
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Approval Retur`);
		this.getOptionReturforAccept().then(() => {
			if (this.$route.params.code) {
				this.por_code = this.$route.params.code
				this.getDetailRetur(this.$route.params.code)
			}
		})
	},
	beforeDestroy() {
		this.clearDataRetur()
	},
	watch: {
	}
}
</script>